import api from '@/api'

const SET_INGREDIENT_TYPES = 'SET_INGREDIENT_TYPES'
const ADD_INGREDIENT_TYPE = 'ADD_INGREDIENT_TYPE'

const SET_INGREDIENT_TYPE = 'SET_INGREDIENT_TYPE'
const UNSET_INGREDIENT_TYPE = 'UNSET_INGREDIENT_TYPE'

export default {
  namespaced: true,

  state () {
    return {
      ingredientTypes: [],
      ingredientTypesList: [],
      currentIngredientType: null
    }
  },

  getters: {
    ingredientTypes: (state) => state.ingredientTypes,
    ingredientTypesList: (state) => state.ingredientTypesList,
    currentIngredientType: (state) => state.currentIngredientType
  },

  mutations: {
    [SET_INGREDIENT_TYPES] (state, data) {
      state.ingredientTypes = data
    },

    [ADD_INGREDIENT_TYPE] (state, data) {
      state.ingredientTypes.shift(data)
    },

    [SET_INGREDIENT_TYPE] (state, data) {
      state.currentIngredientType = data
    },

    [UNSET_INGREDIENT_TYPE] (state) {
      state.currentIngredientType = null
    }
  },

  actions: {
    async loadIngredientTypes ({ commit }, params = {}) {
      const { data, count } = await api.ingredienttypes.list(params)
      commit(SET_INGREDIENT_TYPES, data || [])
      return { data, count }
    },

    async createIngredientType ({ dispatch }, payload) {
      const { error } = await api.ingredienttypes.create(payload)
      const filters = { farm: payload.farm }
      dispatch('loadIngredientTypes', filters)
      return error
    },

    async selectIngredientType ({ commit }, id) {
      const { data } = await api.ingredienttypes.getById(id)
      commit(SET_INGREDIENT_TYPE, data)
      return data
    },

    async updateIngredientType ({ commit, getters }) {
      const item = getters.currentIngredientType
      const { error } = await api.ingredienttypes.updateById(item.id, item)
      if (!error) {
        commit(UNSET_INGREDIENT_TYPE)
      }
      return error
    },

    async deleteIngredientType ({ commit, dispatch, getters }) {
      const item = getters.currentIngredientType
      await api.ingredienttypes.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadIngredientTypes', params)
      commit(UNSET_INGREDIENT_TYPE)
    },

    closeIngredientType ({ commit }) {
      commit(UNSET_INGREDIENT_TYPE)
    }
  }
}
